export class TimeFieldParameter {
  // no definition
}
